<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" :close-on-click="false" :nudge-width="240" offset-x :disabled="disabled">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <span v-if="clickableText" class="clickable-text" :class="disabled ? 'disabled' : ''">
            <strong>{{ clickableText.bold }}</strong>
            {{ clickableText.normal }}
          </span>
          <mf-button v-else color="marca-0-l40" icon="edit" text label="Editar" size="sm" :disabled="disabled" />
        </div>
      </template>

      <v-card class="popover-content">
        <v-card-text class="d-flex flex-column" style="gap: 14px">
          <div class="title-and-subtitle">
            <span class="popover-title">{{ title | truncate({ length: 50 }) }}</span>
            <span v-if="subtitle" class="popover-subtitle">{{ subtitle | truncate({ length: 50 }) }}</span>
          </div>

          <slot></slot>

          <mf-action-buttons
            :primary-button="{
              text: 'Salvar',
              action: save,
              isVisible: true,
              isDisabled: false,
            }"
            :secondary-button="{
              text: 'Cancelar',
              action: cancel,
              isVisible: true,
              isDisabled: false,
            }"
          />
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clickableText: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    menu: false,
  }),
  methods: {
    cancel() {
      this.$emit('cancel')
      this.close()
    },
    save() {
      this.$emit('submit')
    },
    close() {
      this.menu = false
    },
  },
}
</script>

<style lang="scss" scoped>
.title-and-subtitle {
  display: flex;
  flex-direction: column;
  gap: 4px;

  .popover-title {
    font-size: 16px;
    font-weight: bold;
    color: $cinza-d10;
  }

  .popover-subtitle {
    font-size: 14px;
    color: $cinza-l20;
  }
}

.clickable-text {
  font-size: 14px;
  color: $marca-0-l40;
  text-decoration: underline;
}

.disabled {
  color: $cinza-0;
  text-decoration: none;
  cursor: text;
}

.popover-content {
  border-radius: 8px;
  box-shadow: 0px 2px 20px 0px #0000002f;
}
</style>
